import CartModal from './CartModal.view';

export default CartModal;
